module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.e18bbf611f2a2e43afc0.ttf";


//////////////////
// WEBPACK FOOTER
// /home/markush/Projects/fieldsale-wingman-client/src/fonts/glyphicons-halflings-regular.ttf
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.ttf
// module chunks = styles